<!-- 收货地址-添加 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">收货地址</p>
		</div>

		<div class="form-row">
			<span class="form-row-label">收货人</span>
			<input class="form-row-input" type="text" placeholder="收货人" v-model="params.name" />
		</div>

		<div class="form-row">
			<span class="form-row-label">手机号码</span>
			<input class="form-row-input" type="text" placeholder="请填写收货人手机号码" v-model="params.phone" />
		</div>

		<div class="form-row" @click="showPicker = true">
			<span class="form-row-label">所在地区</span>
			<input
          class="form-row-input"
          type="text"
          placeholder="请选择所在地区"
          disabled
          :value="params.pro_name.length > 0 ? `${params.pro_name} ${params.city_name} ${params.county_name}` : ''"
      />
			<img src="../assets/icon-63.png" style="width: 14px;" >
		</div>

		<div class="form-row">
			<span class="form-row-label">详细地址</span>
			<input class="form-row-input" type="text" placeholder="请输入街道、楼牌号" v-model="params.detail" />
		</div>

		<div class="form-row">
			<span class="form-row-label">设为默认地址</span>
      <van-switch v-model="params.is_mr" size="24px" :active-value="1" :inactive-value="0" />
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<!-- 编辑的时候显示删除按钮 添加的时候不显示 -->
				<button type="button" class="footer-btn border" v-if="params.id" @click="delDeliveryAddress(params)">删除</button>
				<button type="button" class="footer-btn" @click="submit()">保存</button>
			</div>
		</div>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
          show-toolbar
          :columns="columns"
          value-key="name"
          :loading="loading"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          @change="onChange"
      />
    </van-popup>

	</div>
</template>

<script>
import {AddressService, AreaService} from "@/common/service";
  import {validatorFun} from "@/common/util";
import {Dialog, Toast} from "vant";

  export default {
		components: {},
		data() {
			return {
        checked: false,
        columns: [{values: []}, {values: []}, {values: []}],
        showPicker: false,
        loading: false,

        params: {
          id: '', // 收货地址记录id（不传值是添加）
          pro_name: '', // 省名
          city_name: '', // 市名
          county_name: '', // 县区名
          detail: '', // 详细地址
          phone: '', // 联系电话
          name: '', // 联系人
          is_mr: 0, // 是否是默认（0不默认，1默认）
        },
			};
		},
		mounted() {
      const option = this.$route.query;
      this.params.id = parseInt(option.id || 0);
      if (this.params.id > 0) {
        this.getDetail();
      }
      this.getAddress();
		},
		methods: {
      delDeliveryAddress(item) {
        Dialog.alert({
          title: '提示',
          message: '确定删除地址？',
          showCancelButton: true,
        }).then(() => {
          AddressService.delDeliveryAddress({id: item.id}).then(({msg}) => {
            Toast(msg);
            setTimeout(() => this.$router.back(), 1000);
          });
        });
      },
      getDetail() {
        AddressService.getDeliveryAddressDetail({ id: this.params.id }).then(({ data }) => {
          this.params = data;
        });
      },
      submit() {
        const params = this.params;
        const errList = validatorFun(params, [
          ['name', ['notNull', '请填写收货人']],
          ['phone', ['notNull', '请填写收货人手机号码']],
          ['county_name', ['notNull', '请选择所在地区']],
          ['detail', ['notNull', '请请填写街道、楼牌号']],
        ]);
        if (errList.length > 0) {
          return Toast(errList[0].errMsg);
        }
        AddressService.setDeliveryAddress(params).then(({msg}) => {
          Toast(msg);
          setTimeout(() => this.$router.back(), 1000);
        });
      },
      getAddress(id = 0, level = 0, picker = null) {
        return AreaService.getAreaChildrenByID({id}).then(({data}) => {
          if (picker) {
            picker.setColumnValues(level, data.list);
          } else {
            this.columns[level].values = data.list;
          }
          if (level < 2) {
            return this.getAddress(data.list[0].id, level + 1, picker);
          }
        });
      },
      onConfirm(val) {
        this.params.pro_name = val[0].name;
        this.params.city_name = val[1].name;
        this.params.county_name = val[2].name;
        this.showPicker = false;
      },
      onChange(picker, values, index) {
        if (index < 2) {
          this.loading = true;
          this.getAddress(values[index].id, index + 1, picker).finally(() => this.loading = false);
        }
      },
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 66px 15px 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 0 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 25px;
		box-sizing: border-box;
	}


	.footer-btn {
		flex: 1;
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
		box-sizing: border-box;
	}

	.footer-btn.border {
		flex: initial;
		width: 115px;
		margin-right: 15px;
		border: 1px solid #2A63F3;
		box-sizing: border-box;
		color: #2A63F3;
		background-color: #FFFFFF;
	}

	.form-row {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 25px;
	}

	.form-row-label {
		width: 109px;
		padding-left: 3px;
		box-sizing: border-box;
	}

	.form-row-input {
		flex: 1;
		font-size: 14px;
		color: #222222;
	}

	.form-row-input::placeholder {
		color: #999;
	}
</style>
